import { render, staticRenderFns } from "./gj-steps.vue?vue&type=template&id=6ddb28d1&scoped=true&"
import script from "./gj-steps.vue?vue&type=script&lang=js&"
export * from "./gj-steps.vue?vue&type=script&lang=js&"
import style0 from "./gj-steps.vue?vue&type=style&index=0&id=6ddb28d1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ddb28d1",
  null
  
)

export default component.exports